import { jsxs as P, Fragment as R, jsx as j } from "react/jsx-runtime";
import { BadRequest as O } from "@systemeio/util";
import { offerDefaultErrors as Y } from "../../pages/checkout/constants/default-errors.mjs";
import { useStore as $, useOfferStore as J, useXenditStore as z } from "../../store/index.mjs";
import G from "../../ui-kit/theme-button.mjs";
import { getCardHolderFirstLastName as K } from "../payment-inputs/get-card-holder-first-last-name.mjs";
import { xenditBuyOffer as Q } from "./api/index.mjs";
import { useLoadXenditScript as U } from "./hooks/use-load-xendit-script.mjs";
import { useXenditThreeDs as V } from "./hooks/use-xendit-three-ds.mjs";
import { XenditCreditCardStatusEnum as n } from "./types/index.mjs";
import { useTranslation as W, ContactSlugEnum as p, toast as a } from "@systemeio/ui";
import { twJoin as Z } from "tailwind-merge";
function le({
  isFetching: _,
  buttonTitle: h,
  buttonDisabled: y,
  setErrors: w,
  setIsFetching: r,
  preSubmit: l,
  handleBadRequest: b,
  hasErrors: x
}) {
  const { t: u } = W(), { locale: N } = $(), { currency: m, finalAmount: i } = J(), { cardNumber: X, cardHolderName: v, cvc: D, expiryMonth: S, expiryYear: E, formInvalid: c } = z(), { isScriptLoading: k } = U(), { openLinkInIframe: f, threeDsModal: B, closeThreeDsModal: H } = V(
    () => r(!1)
  ), L = async (o, e) => {
    if (o) {
      a.error(o.message), r(!1);
      return;
    } else if (e.status === n.in_review)
      f(e.payer_authentication_url);
    else if (e.status === n.verified) {
      setTimeout(() => {
        H();
      }, 1e3);
      try {
        const t = l();
        if (!t) return;
        const { redirect: s } = await Q(
          {
            ...t,
            options: { token: e.credit_card_token_id }
          },
          N
        );
        if (s) {
          window.location.assign(s);
          return;
        } else
          a.error(u("public_pages_purchase.error"));
      } catch (t) {
        if (t instanceof O)
          b(t);
        else
          throw t;
      } finally {
        r(!1);
      }
    }
  }, T = async (o, e) => {
    if (o) {
      a.error(o.message), r(!1);
      return;
    }
    if (!window.Xendit || !i) {
      a.error(u("public_pages_purchase.error")), r(!1);
      return;
    }
    e.status === n.verified ? window.Xendit.card.createAuthentication(
      {
        amount: i,
        token_id: e.id
      },
      L
    ) : e.status === n.in_review ? f(e.payer_authentication_url) : e.status === n.failed && (a.error(u("public_pages_purchase.error")), r(!1));
  }, g = async (o) => {
    o.preventDefault();
    try {
      const e = l();
      if (!e || !i || !m) return;
      if (r(!0), w(Y), window.Xendit) {
        const t = `20${E}`, { firstName: s, lastName: q } = K(v), A = e.customer.fields[p.Email] ?? "", d = e.customer.fields[p.PhoneNumber] ?? "", M = d ? `+${d}` : "";
        window.Xendit.card.createToken(
          {
            amount: i,
            card_number: X,
            card_exp_month: S,
            card_exp_year: t,
            card_cvn: D,
            card_holder_first_name: s,
            card_holder_last_name: q,
            card_holder_email: A,
            card_holder_phone_number: M,
            is_multiple_use: !0,
            should_authenticate: !0,
            currency: m
          },
          T
        );
      }
    } catch (e) {
      throw e;
    } finally {
      r(!1);
    }
  };
  return /* @__PURE__ */ P(R, { children: [
    B,
    /* @__PURE__ */ j(
      G,
      {
        className: Z(
          "main-transition-colors",
          (x || c) && "bg-danger focus:bg-danger"
        ),
        onClick: g,
        isFetching: _,
        disabled: k || c || y,
        type: "submit",
        children: h
      }
    )
  ] });
}
export {
  le as XenditPaymentButton
};
